import { render, staticRenderFns } from "./TaskNew.vue?vue&type=template&id=0ab5273b"
import script from "./TaskNew.vue?vue&type=script&lang=js"
export * from "./TaskNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports